/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Show_BodyInputs */

const en_landing_how_show_body = /** @type {(inputs: Landing_How_Show_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We remind you the day before.`)
};

const pl_landing_how_show_body = /** @type {(inputs: Landing_How_Show_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnimy Ci dzień wcześniej.`)
};

/**
* | output |
* | --- |
* | "We remind you the day before." |
*
* @param {Landing_How_Show_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_show_body = /** @type {((inputs?: Landing_How_Show_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Show_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_show_body(inputs)
	return en_landing_how_show_body(inputs)
});